(function($) {
	'use strict';

	var BackStretch = {

		/**
		 * Sets up Backstretch carousel
		 *
		 * @returns {void} Delegates to event handlers.
		 */
		init: function() {
			var bg_images = GN.background_images,
				singleImage = 1;

			if ( ! bg_images || bg_images.length === 0 ) {
				return;
			}

			if ( bg_images.length === singleImage ) {
				this.setSingleBackgroundImage( bg_images[0] );
			} else {
				this.setMultipleBackgroundImages( bg_images );
			}
		},

		/**
		 * If there is only a single image, pass it to backstretch.
		 *
		 * @param {string} image Single image URL.
		 * @returns {void}
		 */
		setSingleBackgroundImage: function( image ) {
			$.backstretch( image );
		},

		/**
		 * If there are multiple images, create a carousel.
		 *
		 * @param {array} images List of image URLs.
		 * @returns {void}
		 */
		setMultipleBackgroundImages: function( images ) {
			$.backstretch( images, {
				duration: 5000,
				fade: 750,
			})
		}
	}

	BackStretch.init();
})( jQuery );

/* eslint-disable complexity */
/**
 * Uses the MicroModal library (https://github.com/ghosh/micromodal) to open a modal
 * embedded in the footer.
 *
 * Checks for a cookie first, the "popup" cookie with a value of true. Uses the
 * js-cookie library (https://github.com/js-cookie/js-cookie) to verify.
 */
var GN_Popup = {

		getCookie: function( name ) {
			'use strict';

			var nameEQ = name + '=',
				ca = document.cookie.split( ';' ),
				i,
				c;

			for ( i = 0; i < ca.length; i++ ) {
				c = ca[i];
				while ( ' ' === c.charAt( 0 ) ) {
					c = c.substring( 1, c.length );
				}
				if ( 0 === c.indexOf( nameEQ ) ) {
					return c.substring( nameEQ.length, c.length );
				}
			}
			return null;
		},

		/**
		 * Sets up modal, checks for cookie.
		 *
		 * @param {boolean} override Override status for use with customizer.
		 * @returns {void}
		 */
		init: function( override ) {
			'use strict';

			var popupCookie = GN_Popup.getCookie( popupCookieName ),
				popupCookieName = 'GnPopup',
				override = override || false,
				modal = document.getElementById( 'popup-modal' ),
				alwaysOn = modal.getAttribute( 'data-always-on' );

			if (
				'true' === popupCookie &&
				! ( override || 'true' === alwaysOn )
			) {
				return;
			}

			MicroModal.init();
			MicroModal.show( 'popup-modal' );
			if (
				Cookies &&
				typeof Cookies !== 'undefined' &&
				'true' !== alwaysOn
			) {
				Cookies.set( popupCookieName, 'true', { expires: 7 } );
			}

			if (
				Cookies &&
				typeof Cookies !== 'undefined' &&
				'true' === alwaysOn
			) {
				Cookies.set( popupCookieName, 'true' );
			}
		}
	},

	popupEl = document.getElementById( 'popup-modal' );

if ( popupEl ) {
	GN_Popup.init();
}

if ( window.wp && window.wp.customize ) {
	wp.customize.bind( 'preview-ready', function() {
		'use strict';

		wp.customize.preview.bind( 'popup', function( status ) {
			if ( true === status ) {
				GN_Popup.init( true );
			}
		} );
	} );
}
